import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";

/**
 * DS Counter — Figma 333:8006 (component) / 333:7974 (variants).
 *
 * 구조: [- 42×42] gap16 [숫자 64w] gap16 [+ 42×42], 컨테이너 border 1px Border/Default radius 6.
 * 총 사이즈: 180×42. 버튼 hover bg Paper, disabled icon Text/Disabled.
 *
 * @param {object} props
 * @param {number} props.value
 * @param {(value: number) => void} props.onChange
 * @param {number} [props.min=0]
 * @param {number} [props.max=999]
 * @param {boolean} [props.disabled]
 */
const DSCounter = ({
  value,
  onChange,
  min = 0,
  max = 999,
  disabled = false,
}) => {
  const n = Number(value) || 0;
  const minusDisabled = disabled || n <= min;
  const plusDisabled = disabled || n >= max;

  const handleDec = () => {
    if (minusDisabled) return;
    onChange && onChange(n - 1);
  };
  const handleInc = () => {
    if (plusDisabled) return;
    onChange && onChange(n + 1);
  };
  const handleInput = (e) => {
    if (disabled) return;
    const v = Number(e.target.value);
    if (Number.isNaN(v)) return;
    onChange && onChange(Math.max(min, Math.min(max, v)));
  };

  return (
    <div className="ds-counter">
      <button
        type="button"
        className="ds-counter__btn"
        disabled={minusDisabled}
        onClick={handleDec}
        aria-label="감소"
      >
        <FontAwesomeIcon icon={faMinus} />
      </button>
      <input
        type="number"
        className="ds-counter__input"
        value={n}
        onChange={handleInput}
        disabled={disabled}
      />
      <button
        type="button"
        className="ds-counter__btn"
        disabled={plusDisabled}
        onClick={handleInc}
        aria-label="증가"
      >
        <FontAwesomeIcon icon={faPlus} />
      </button>
    </div>
  );
};

export default React.memo(DSCounter);
